import Papa from "papaparse"

export const parseCsvAndFindProductUrls = (
	csvFile,
	setMultilinkProductUrls,
	submit,
) => {
	Papa.parse(csvFile, {
		header: true,
		complete: (results) => {
			let productUrls = []

			let products = results.data.map((row) => {
				if (row["Product URL"]) {
					productUrls.push(row["Product URL"])
				}
			})

			setMultilinkProductUrls(productUrls)
			submit(productUrls)
		},
	})
}
